import { ITag } from '@/store/models/interfaces/tag.interface';

export class Tag implements ITag {
    id: number;
    name: string;
}
